import * as React from 'react'

export const ManWithSuccessSecondary = () => {
  return (
    <svg width='360' height='360' viewBox='0 0 360 360' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M152.928 166.998C32.0623 165.134 45.1664 181.419 44.5391 107.294C45.5208 72.4552 40.5227 50.7153 52.0749 43.6654C60.0017 36.6115 90.0959 41.1499 124.162 39.9288C148.239 40.7429 162.284 35.8585 169.841 50.5647C173.409 60.9198 171.026 58.4084 171.69 66.4596C170.505 147.688 178.558 164.275 152.928 166.998Z'
        fill='url(#paint0_linear_3473_30744)'
      />
      <path
        d='M296.29 166.998C175.426 165.134 188.53 181.419 187.899 107.293C188.88 72.4551 183.882 50.7152 195.434 43.6653C203.377 36.6114 233.455 41.1498 267.524 39.9287C291.601 40.7428 305.646 35.8583 313.202 50.5646C316.77 60.9197 314.387 58.4082 315.051 66.4594C313.866 147.688 321.911 164.275 296.29 166.998Z'
        fill='url(#paint1_linear_3473_30744)'
      />
      <path
        d='M152.925 310.346C32.0626 308.476 45.1664 324.928 44.5391 250.044C45.5207 214.849 40.5228 192.887 52.0746 185.765C60.0013 178.639 90.0947 183.215 124.172 182.002C148.249 182.8 162.294 177.857 169.849 192.731C173.418 203.196 171.035 200.659 171.699 208.792C170.501 290.851 178.554 307.608 152.925 310.346Z'
        fill='url(#paint2_linear_3473_30744)'
      />
      <path
        d='M296.288 310.346C175.426 308.476 188.53 324.928 187.899 250.044C188.88 214.849 183.882 192.887 195.434 185.765C203.361 178.639 233.45 183.215 267.531 182.002C291.608 182.8 305.652 177.857 313.208 192.731C316.776 203.196 314.393 200.659 315.057 208.792C313.864 290.851 321.908 307.608 296.288 310.346Z'
        fill='url(#paint3_linear_3473_30744)'
      />
      <path
        d='M300.931 79.7573C298.92 130.611 226.437 136.428 222.828 85.7406C223.551 33.5469 298.542 27.6514 300.931 79.7573Z'
        fill='url(#paint4_linear_3473_30744)'
      />
      <path
        d='M303.071 79.7572C301.064 130.611 228.581 136.427 224.967 85.7405C225.695 33.5467 300.687 27.6513 303.071 79.7572Z'
        fill='url(#paint5_linear_3473_30744)'
      />
      <path
        d='M257.405 99.6841C255.758 100.782 241.076 83.8691 239.935 83.2365C244.175 76.647 243.797 77.6442 248.299 82.2569C253.52 87.1947 257.325 92.5278 257.933 91.0122L283.151 65.2602C284.039 64.0301 290.055 69.9871 287.284 70.5582C280.798 76.4361 259.696 100.484 257.405 99.6841Z'
        fill='white'
      />
      <path
        d='M155.145 115.982C143.801 119.386 129.291 132.629 121.698 139.89C104.194 156.636 71.3511 213.137 90.4826 233.323C103.504 247.049 126.396 241.282 136.474 227.44C143.895 217.262 139.4 207.996 137.826 189.671C136.176 169.941 143.296 135.465 155.145 115.982Z'
        fill='url(#paint6_linear_3473_30744)'
      />
      <path
        d='M145.587 121.413C137.769 130.629 135.023 129.86 128.931 142.548C119.746 161.66 126.51 183.506 127.475 207.048C128.53 232.872 127.475 280.939 114.399 305.778C114.15 306.115 114.032 306.53 114.065 306.946C114.466 333.284 239.865 314.834 239.671 305.215C238.683 257.456 207.333 152.86 215.097 118.268C211.575 118.205 204.6 114.55 201.759 113.763C190.496 110.54 178.672 109.724 167.068 111.369C162.856 111.937 160.755 112.899 157.662 114.053C152.68 115.977 149.46 118.791 145.587 121.413Z'
        fill='url(#paint7_linear_3473_30744)'
      />
      <path
        d='M190.216 85.0175C190.053 93.0347 192.705 104.586 193.751 111.776C194.797 118.965 179.985 119.27 175.142 115.937C170.696 112.876 174.047 104.573 178.335 100.215C182.623 95.8577 185.837 89.4779 190.216 85.0175Z'
        fill='url(#paint8_linear_3473_30744)'
      />
      <path
        d='M167.942 82.5077C161.116 76.5306 159.862 55.3197 166.779 51.1635C170.134 49.1502 175.986 59.6102 179.792 61.6324C184.9 64.3168 198.774 67.3546 201.52 72.7904C203.594 76.8885 199.433 85.3889 197.76 88.4267C195.866 91.8626 195.645 90.6905 193.373 93.1288C190.216 96.511 186.028 100.47 182.831 104.264C182.136 101.379 182.321 101.383 181.099 97.6564C180.648 96.2247 176.861 90.167 175.026 87.8138C173.862 86.3463 168.776 83.2414 167.942 82.5077Z'
        fill='url(#paint9_linear_3473_30744)'
      />
      <path
        d='M189.828 99.0032C184.579 103.822 182.014 109.687 172.486 107.951C163.96 106.376 162.53 85.2549 170.286 79.0227C172.874 76.9424 176.652 76.9647 179.867 77.9132C181.766 78.4769 183.745 79.7296 185.643 80.4499C187.393 81.1165 188.872 80.3068 190.477 82.0695C192.488 84.2706 191.122 89.8899 189.972 92.6055C190.851 91.8405 191.843 90.7623 192.997 90.4044C193.814 90.1538 195.225 88.8117 195.991 89.957C197.245 91.8494 194.53 95.4644 192.934 96.9542C191.958 97.7212 190.918 98.4065 189.828 99.0032Z'
        fill='url(#paint10_linear_3473_30744)'
      />
      <path
        d='M191.09 80.6959C189.923 81.3625 191.992 83.501 191.69 85.6172C191.086 89.7242 189.765 97.1465 183.718 97.8668C180.143 98.2918 176.4 95.1242 172.653 94.735C170.246 94.4767 167.812 94.6479 165.466 95.2406C163.974 99.6653 163.91 106.631 167.779 109.374C171.945 112.326 174.673 110.792 179.097 109.526C182.059 108.676 185.323 106.143 187.186 103.262C189.124 100.26 190.549 97.1062 192.47 93.9476C193.534 92.2028 194.819 90.0195 196.077 88.1897C196.514 87.5806 196.882 86.9266 197.177 86.2391C196.172 85.2951 192.781 79.7251 191.09 80.6959Z'
        fill='url(#paint11_linear_3473_30744)'
      />
      <path
        d='M170.173 98.2827C171.931 99.258 173.992 99.2491 175.908 99.2759C175.998 99.2759 176.413 99.1149 176.255 99.4638C175.656 100.761 173.068 101.209 171.747 100.833C170.813 100.564 169.235 99.437 169.406 98.4214C169.483 97.9964 169.997 98.3722 170.173 98.2827Z'
        fill='url(#paint12_linear_3473_30744)'
      />
      <path
        d='M156.592 273.696C153.229 269.92 147.877 263.925 147.575 255.55C146.758 234.021 180.319 225.637 178.997 208.126C177.974 194.508 157.427 196.047 145.735 171.887C143.728 167.736 136.383 151.965 141.713 134.101C143.43 128.383 146.217 123.037 149.928 118.344C148.485 119.355 147.083 120.397 145.586 121.404C137.768 130.62 135.022 129.851 128.93 142.539C119.745 161.651 126.509 183.497 127.474 207.039C128.529 232.862 127.474 280.93 114.398 305.769C114.157 306.11 114.039 306.521 114.064 306.937C116.99 333.114 239.864 314.824 239.67 305.205C239.552 299.448 238.989 292.857 238.11 285.668C233.768 286.871 180.693 300.696 156.592 273.696Z'
        fill='url(#paint13_linear_3473_30744)'
      />
      <path
        d='M121.369 191C114.507 190.66 119.245 186.526 117.167 187.139C115.868 187.515 84.0351 218.568 94.0675 234.952C103.631 250.575 143.373 239.981 157.378 235.023C165.16 232.272 188.268 223.745 202.309 201.563C203.567 199.568 204.514 197.85 205.141 196.642C174.462 192.66 159.772 191.716 152.062 191.658C147.138 191.631 142.142 192.034 121.369 191Z'
        fill='url(#paint14_linear_3473_30744)'
      />
      <path
        d='M132.962 187.846C133.828 194.704 137.399 215.87 155.412 233.216C158.992 236.665 183.291 259.272 217.356 253.576C243.959 249.125 267.685 228.889 273.163 203.621C283.858 154.283 220.327 110.76 205.718 118.223C195.925 123.234 193.129 158.935 207.788 176.961C210.976 180.88 216.901 186.32 215.981 193.147C215.102 199.706 208.41 203.849 204.618 206.122C186.74 216.859 147.576 189.152 137.214 186.884C136.484 186.857 135.92 186.155 132.962 187.846Z'
        fill='url(#paint15_linear_3473_30744)'
      />
      <path
        d='M228.006 176.728C221.833 170.523 214.682 167.257 206.638 164.801C204.632 164.264 202.621 163.763 200.637 163.248C202.278 168.317 204.632 173.055 207.806 176.961C210.98 180.867 216.919 186.32 215.999 193.147C215.12 199.706 208.428 203.849 204.636 206.122C186.758 216.859 147.594 189.152 137.232 186.884C136.484 186.862 135.92 186.159 132.962 187.85C133.285 190.395 133.736 192.921 134.315 195.42C149.014 190.749 164.976 205.384 177.673 212.537C194.009 221.709 214.34 227.637 230.27 215.526C242.205 206.65 237.872 186.911 228.006 176.728Z'
        fill='url(#paint16_linear_3473_30744)'
      />
      <path
        d='M202.309 201.558C203.157 203.572 207.354 205.643 209.392 205.406C212.81 205.012 215.222 202.722 217.364 201.697C219.28 200.802 223.55 199.576 223.807 198.069C224.294 195.214 219.628 194.409 216.886 194.132C213.049 193.747 208.955 194.856 205.163 196.646C204.194 198.306 203.129 199.925 202.309 201.558Z'
        fill='url(#paint17_linear_3473_30744)'
      />
      <path
        d='M126.811 191.268C140.22 193.134 143.318 192.217 143.692 191.045C144.166 189.55 140.536 186.522 136.694 186.003C132.853 185.484 128.813 187.537 126.811 191.268Z'
        fill='url(#paint18_linear_3473_30744)'
      />
      <defs>
        <linearGradient id='paint0_linear_3473_30744' x1='44.2784' y1='103.459' x2='171.999' y2='103.459' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#F1FFFF' />
          <stop offset='1' stopColor='#E7F6FD' />
        </linearGradient>
        <linearGradient id='paint1_linear_3473_30744' x1='55537.8' y1='29936.4' x2='95584.5' y2='29936.4' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#F1FFFF' />
          <stop offset='1' stopColor='#E7F6FD' />
        </linearGradient>
        <linearGradient id='paint2_linear_3473_30744' x1='10711.5' y1='75522.4' x2='50758.2' y2='75522.4' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#F1FFFF' />
          <stop offset='1' stopColor='#E7F6FD' />
        </linearGradient>
        <linearGradient id='paint3_linear_3473_30744' x1='55537.8' y1='75522.4' x2='95584.5' y2='75522.4' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#F1FFFF' />
          <stop offset='1' stopColor='#E7F6FD' />
        </linearGradient>
        <linearGradient id='paint4_linear_3473_30744' x1='222.828' y1='120.957' x2='300.931' y2='120.957' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#F588B8' />
          <stop offset='1' stopColor='#FF4086' />
        </linearGradient>
        <linearGradient id='paint5_linear_3473_30744' x1='224.967' y1='120.957' x2='303.071' y2='120.957' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#E94086' />
          <stop offset='1' stopColor='#FF4086' />
        </linearGradient>
        <linearGradient id='paint6_linear_3473_30744' x1='234.139' y1='171.253' x2='111.98' y2='130.519' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#3A3CA6' />
          <stop offset='0.51' stopColor='#54A0FC' />
        </linearGradient>
        <linearGradient id='paint7_linear_3473_30744' x1='266.131' y1='300.853' x2='141.149' y2='126.621' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#475CA3' />
          <stop offset='1' stopColor='#54A0FC' />
        </linearGradient>
        <linearGradient id='paint8_linear_3473_30744' x1='150.864' y1='100.793' x2='197.186' y2='168.648' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#893976' />
          <stop offset='1' stopColor='#311944' />
        </linearGradient>
        <linearGradient id='paint9_linear_3473_30744' x1='209.758' y1='81.2722' x2='186.422' y2='22.3606' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#26264F' />
          <stop offset='1' stopColor='#444B8C' />
        </linearGradient>
        <linearGradient id='paint10_linear_3473_30744' x1='3699.18' y1='131.168' x2='3769.7' y2='109.426' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#893976' />
          <stop offset='1' stopColor='#311944' />
        </linearGradient>
        <linearGradient id='paint11_linear_3473_30744' x1='3728.02' y1='98.3701' x2='3740.2' y2='35.3809' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#26264F' />
          <stop offset='1' stopColor='#444B8C' />
        </linearGradient>
        <linearGradient id='paint12_linear_3473_30744' x1='3600.25' y1='80.4194' x2='3596.61' y2='165.2' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#893976' />
          <stop offset='1' stopColor='#311944' />
        </linearGradient>
        <linearGradient id='paint13_linear_3473_30744' x1='264.581' y1='317.921' x2='137.916' y2='146.337' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#475CA3' />
          <stop offset='0.9' stopColor='#54A0FC' />
        </linearGradient>
        <linearGradient id='paint14_linear_3473_30744' x1='217.637' y1='290.719' x2='216.659' y2='227.103' gradientUnits='userSpaceOnUse'>
          <stop offset='0.03' stopColor='#3A3CA6' />
          <stop offset='0.19' stopColor='#3B41AB' />
          <stop offset='0.41' stopColor='#3F51B8' />
          <stop offset='0.64' stopColor='#466ACE' />
          <stop offset='0.89' stopColor='#4F8DEC' />
          <stop offset='1' stopColor='#54A0FC' />
        </linearGradient>
        <linearGradient id='paint15_linear_3473_30744' x1='2432.39' y1='338.978' x2='2440.06' y2='88.7645' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#3A3CA6' />
          <stop offset='0.51' stopColor='#54A0FC' />
        </linearGradient>
        <linearGradient id='paint16_linear_3473_30744' x1='2306.19' y1='254.021' x2='2307.3' y2='147.473' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#475CA3' />
          <stop offset='0.9' stopColor='#54A0FC' />
        </linearGradient>
        <linearGradient id='paint17_linear_3473_30744' x1='3619.6' y1='173.778' x2='3620.78' y2='215.354' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#893976' />
          <stop offset='1' stopColor='#311944' />
        </linearGradient>
        <linearGradient id='paint18_linear_3473_30744' x1='3682.01' y1='165.684' x2='3682.62' y2='207.227' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#893976' />
          <stop offset='1' stopColor='#311944' />
        </linearGradient>
      </defs>
    </svg>
  )
}
